import $ from 'jquery'
import {EVENT_MAP_TOOL_ACTIVE,EVENT_MAP_TOOL_IN_ACTIVE,EVENT_MAP_TOOL_BIND,EVENT_MAP_TOOL_REMOVE} from "./Constants";
import mapboxgl from "mapbox-gl";

/**
 * 工具基类
 */
export default class Base {
  /**
   *
   * @param map 地图实例
   * @param funId 功能id
   * @param callBack 成功回调
   * @param errorCallBack 失败回调
   * @param showIcon[boolean]  是否展示图标
   * @param iconCLassName 图标类名
   * @param callBackName 回调地图事件名
   * @param errorEventName 错误回调底图事件名
   * @param chineseName 汉字名称
   * @param innerUse 内部使用
   */
  constructor(map,funId,{callBack:callBack,errorCallBack:errorCallBack,cancelCallback: cancelCallback,showIcon=false,iconCLassName="iconfont-map map-icon-gongju",callBackName="",errorEventName="",chineseName="未命名",innerUse=false}) {
    // if(!map){
    //   throw new Error("需要传入地图对象")
    // }
    if(!funId){
      throw new Error("需要传入工具名称")
    }

    this.map = map;
    this.funId=funId;
    this.popupClassName="toolPopup"

    this.showIcon=showIcon;
    this.iconCLassName=iconCLassName;
    this.callBackName=callBackName;
    this.errorEventName=errorEventName;
    this.chineseName=chineseName;
    this.innerUse=innerUse;

    if(callBack){
      this.callBack=callBack;
    }
    if(errorCallBack){
      this.errorCallBack=errorCallBack;
    }
    if(cancelCallback){
      this.cancelCallback = cancelCallback;
    }
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|OperaMini/i.test(navigator.userAgent);

  }

  /**
   * 启动功能
   */
  start() {
    if(!this.map){
      throw new Error("map不能为null")
      this.error("map不能为null")
    }
    if(this.btn){
      this.btn.className="mapboxgl-ctrl editToolBtn active";
    }
    this.map.curFunId=this.funId;

  }

  /**
   * 当被挂载到mapbox上
   * @param map
   */
  onAdd(map){
    if(this.map){
      throw new Error("不允许两种插件方法，同时使用")
    }
   this.map=map;
   let ui=this._createIcon();

   //触发绑定事件
    this._fireEvent(EVENT_MAP_TOOL_BIND)

    return ui;
  }

  /**
   * 从控件组移除时触发
   */
  onRemove(){
    //移除控件按钮
    if(this.btn){
      this.btn.parentNode.removeChild(this.btn);
    }
    this.close();
    this._fireEvent(EVENT_MAP_TOOL_REMOVE)
  }

  /**
   *激活图标
   */
  activeIcon(){
    this._fireEvent(EVENT_MAP_TOOL_ACTIVE)
    this.start();
  }

  /**
   * 冻结图标
   */
  inActiveIcon(){
    if(this.btn){
      this.btn.className="mapboxgl-ctrl editToolBtn";
    }
    this._fireEvent(EVENT_MAP_TOOL_IN_ACTIVE)

    this.close();
  }

  _fireEvent(name){
    if(this.funId&&!this.innerUse){
      this.map.fire(name,this.funId)
    }
  }



  /**
   * 产生li标签
   * @private
   */
  _createIcon() {
    let container = document.createElement("div");
    if(!this.showIcon){
      return container
    }
    container.className="mapboxgl-ctrl editToolBtn"
    container.title=this.chineseName;
    let span = document.createElement("span");
    span.className = this.iconCLassName;
    container.appendChild(span);
    let div = document.createElement("div");
    div.innerText = this.chineseName;
    container.appendChild(div);
    this.btn=container
    //点击切换状态
    container.addEventListener("click",()=>{
      console.log(container.className)
      if(container.className.indexOf("active")>-1){
        //关闭
        this.inActiveIcon();
      }else {
        //激活
        this.activeIcon();
      }

    })
    return container;
  }
  /**
   * 关闭功能
   */
  close() {
    this.clear();
  }

  /**
   * 清除绘制效果
   */
  clear() {
    this.clearMap();
    this.clearEvent();
  }

  /**
   * 清除地图内容
   */
  clearMap() {
    //清除选择图层
    if (this.map.getLayer('selectionSetDraw')) {
      this.map.removeLayer('selectionSetDraw');
    }
    if (this.map.getSource('selectionSetDraw')) {
      this.map.removeSource('selectionSetDraw');
    }
  }

  /**
   * 清除地图事件
   */
  clearEvent() {

  }

  /**
   * 根据className移除popup
   */
  clearPopup(){
    if(this.popup){
      this.popup.remove();
      this.popup=null;
    }
    $("."+this.popupClassName).remove();
  }

  addPopup(text,centerFeature){
    //存在先清除
    if(this.popup){
      this.clearPopup();
    }

    this.popup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick:false,
      className:this.popupClassName
    });
    this.popup.setLngLat(centerFeature.geometry.coordinates)
      .setText(text)
      .addTo(this.map);
  }
 addPopupHtml(text,centerFeature){
    //存在先清除
    if(this.popup){
      this.clearPopup();
    }

    this.popup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick:false,
      className:this.popupClassName
    });
    this.popup.setLngLat(centerFeature.geometry.coordinates)
      .setHTML(text)
      .addTo(this.map);
  }

  /**
   * 错误回调
   * @param e
   */
  error(...e){
    if(this.errorCallBack){
      this.errorCallBack(e);
    }
    //触发地图事件
    if(this.errorEventName){
      this.map.fire(this.errorEventName,e)
    }
  }

  cancels(){
    if(this.cancelCallback){
      let params = {
        msg:'取消绘制'
      }
      console.log("取消事件")
      this.cancelCallback(params)
    }
  }

  /**
   * 完成回调
   * @param e
   */
  finish(e){
    if(this.callBack){
      this.callBack(e);
    }
    //触发地图事件
    if(this.callBackName){
      this.map.fire(this.callBackName,e)
    }
  }

  /**
   * 允许地图移动
   */
  enableViewMap() {
    this.map.dragPan.enable();
    this.map.touchZoomRotate.enable();
    this.map.doubleClickZoom.enable();
  }
  /**
   * 禁止地图移动
   */
  disableMap() {
    // //禁止拖拽地图
    this.map.dragPan.disable();
    // //禁止通过捏合屏幕进行缩放
    this.map.touchZoomRotate.disable();
    // //禁止双击缩放
    this.map.doubleClickZoom.disable();
  }

  /**
   * 手动停止
   */
  closeByHand(){

  }
  /**
   * 获取当前要素
   */
  getCurFeatures(){

  }

  _preventDefault(e) {
    if(e.preventDefault){
      e.preventDefault();
    }
  }
}





// WEBPACK FOOTER //
// ./src/tool/edit/Base.js